import Qualitative from "./Qualitative.jsx";

export default Qualitative